import { track } from "@/lib/track";

const INSTALL_TRACKED = "pettok_app_install_tracked";
const OPEN_TRACKED = "pettok_app_open";

export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const platform = () => {
  const ua = navigator.userAgent;
  if (/iphone|ipad|ipod/i.test(ua)) return "ios";
  return /android/i.test(ua) ? "android" : "other";
};

const trackInstallOnce = () => {
  if (localStorage.getItem(INSTALL_TRACKED)) return;
  localStorage.setItem(INSTALL_TRACKED, "1");
  track("app_install", { platform: platform() });
};

// Android fires appinstalled; iPhone has no event, so its first home-screen launch counts as the install.
export const trackAppUsage = () => {
  window.addEventListener("appinstalled", trackInstallOnce);
  if (!isStandalone()) return;
  trackInstallOnce();
  if (!sessionStorage.getItem(OPEN_TRACKED)) {
    sessionStorage.setItem(OPEN_TRACKED, "1");
    track("app_open", { platform: platform() });
  }
};
